// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3u5qs","label":"Section_label__iXqC2","contentWrap":"Section_contentWrap__HI9yn","footer":"Section_footer__2IzQf","footerInner":"Section_footerInner__2QvUm"};